import { useState } from "react";
import { ShieldAlert, X } from "lucide-react";

const KEY = "privacy_notice_dismissed";

export default function PrivacyNotice() {
  const [show, setShow] = useState(() => sessionStorage.getItem(KEY) !== "1");
  if (!show) return null;
  return (
    <div
      data-testid="privacy-notice-bar"
      className="flex items-start gap-2.5 px-4 py-2.5 bg-amber-50 dark:bg-amber-950/40 border-b border-amber-200 dark:border-amber-900 text-amber-900 dark:text-amber-200"
    >
      <ShieldAlert className="h-4 w-4 mt-0.5 shrink-0" />
      <p className="text-xs md:text-sm flex-1 leading-snug">
        Bu ekrandaki veriler gizlidir; görüntü alınması kayıt altındadır.
      </p>
      <button
        onClick={() => { sessionStorage.setItem(KEY, "1"); setShow(false); }}
        className="p-1 rounded hover:bg-amber-100 dark:hover:bg-amber-900/60 transition-colors"
        aria-label="Uyarıyı kapat"
        data-testid="privacy-notice-close"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
